var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"ma-3 pa-6",attrs:{"outlined":"","tile":""}},[_c('h3',[_vm._v("This is the home page")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }